module.exports = __webpack_public_path__ + "img/sidemobwhite.0b2d83e9.png";